export const formatDate = (date) => {
	return date.match(/([0-9]){4}\-([0-9]){2}\-([0-9]){2}/)[0];
};
